import axios from 'axios'
import { ThunkAction } from 'store/types'
import { TokenStorage } from 'services/tokenService'
import { AccountPayloadType, ILoginPayload } from 'ducks/auth/types'
import { reduceParams } from 'utils/helpers'
import { history, routePath } from 'routes'
import {
  handleErrorMessageAlert,
  handleSuccessMessageAlert
} from 'components/UI/Alert'
import * as actions from './actions'
import { parseJwt } from '../../services/parse'
import { finishLoading, startLoading } from '../loading/actions'

export const createAccount = (user: AccountPayloadType): ThunkAction => {
  return async dispatch => {
    dispatch(actions.createAccountRequest())

    try {
      await axios.post('/public/registration', {
        ...reduceParams(user)
      })
      const { email, mobileNumber, firstName, lastName } = user
      dispatch(
        actions.createAccountSuccess({
          email,
          mobileNumber,
          firstName,
          lastName
        })
      )
      history.push(routePath.CHECK_EMAIL)
    } catch (err) {
      console.log('err', err)
      let errorText = ''
      if (Array.isArray(err.response.data.errors)) {
        err.response.data.errors.map((item: string) => {
          errorText = errorText ? errorText + '/' + item : item
          return errorText
        })
      } else {
        errorText =
          err.response && err.response.data && err.response.data.errorMessage
      }
      handleErrorMessageAlert(errorText) // err.response.data.errorMessage
      dispatch(actions.createAccountFail(err))
    }
  }
}

export const login = (user: ILoginPayload): ThunkAction => {
  // console.log('Test')
  // axios.post('/authenticate', {
  //     ...user
  //   })
  //   .then(res => {
  //     console.log('res', res)
  //   })
  //   .catch(err => {
  //     console.log('err', err)
  //   })
  return async dispatch => {
    dispatch(actions.loginRequest())
    // @ts-ignore
    dispatch(startLoading())
    try {
      const resp = await axios.post('/authenticate', {
        ...user
      })
      console.log('response', resp)
      if (resp.status === 200) {
        dispatch(actions.loginSuccess(resp.data))
        TokenStorage.storeToken(resp.data.access_token)
        TokenStorage.storeRefreshToken(resp.data.refresh_token)
        history.push(routePath.ESTIMATES_PAGE)
        if (parseJwt(resp.data.access_token).auth === 'ROLE_ADMIN') {
          dispatch(actions.admin(true))
        }
      } else {
        if (resp && resp.data && resp.data.errorMessage) {
          handleErrorMessageAlert(resp.data.errorMessage)
          dispatch(actions.loginFail(resp.data.errorMessage))
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errorMessage) {
        handleErrorMessageAlert(
          err.response && err.response.data && err.response.data.errorMessage
          )
        dispatch(actions.loginFail(err))
      }
    }
    // @ts-ignore
    dispatch(finishLoading())
  }
}

export const getVerification = (code: string): ThunkAction => {
  return async dispatch => {
    dispatch(actions.getVerificationRequest())

    try {
      const params = {
        verification_code: code
      }

      const resp = await axios.get('/public/verification', {
        params
      })
      TokenStorage.storeToken(resp.data.access_token)
      TokenStorage.storeRefreshToken(resp.data.refresh_token)
      history.push(routePath.ESTIMATES_PAGE)
      dispatch(actions.getVerificationSuccess(resp.data))
    } catch (err) {
      handleErrorMessageAlert(err.response.data.errorMessage)
      dispatch(actions.getVerificationFail(err))
    }
  }
}

export const resendCode = (email: string): ThunkAction => {
  return async dispatch => {
    dispatch(actions.resendCodeRequest())

    try {
      const resp = await axios.post('/public/verification/resend', {
        email
      })

      handleErrorMessageAlert('New code was sent to your email')
      dispatch(actions.resendCodeSuccess(resp.data))
    } catch (err) {
      handleErrorMessageAlert(err.response.data.errorMessage)
      dispatch(actions.resendCodeFail(err))
    }
  }
}

export const fetchTermsAndConditions = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.fetchTermConditionsRequest())

    try {
      const resp = await axios.get('/public/termsAndConditions')

      dispatch(actions.fetchTermConditionsSuccess(resp.data))
    } catch (err) {
      dispatch(actions.fetchTermConditionsFail(err))
    }
  }
}

export const resetPassword = (userEmail: string): ThunkAction => {
  return async dispatch => {
    dispatch(actions.resendCodeRequest())

    try {
      const resp = await axios.post('/public/password/reset', {
        userEmail
      })

      dispatch(actions.resendCodeSuccess(resp.data))
    } catch (err) {
      dispatch(actions.resendCodeFail(err))
    }
  }
}

export const logout = (): ThunkAction => async dispatch => {
  TokenStorage.clear()
  dispatch(actions.logout())
  history.push(routePath.AUTH)
  dispatch(actions.admin(false))
}

export const clearRegistrationData = (): ThunkAction => async dispatch => {
  dispatch(actions.clearRegistrationData())
}

export const changePassword = (
  currentPassword: string,
  newPassword: string
): ThunkAction => async dispatch => {
  dispatch(actions.changePasswordRequest())
  try {
    const resp = await axios.put('/users/passwords', {
      currentPassword,
      newPassword
    })
    dispatch(actions.changePasswordSuccess(resp.data))
    handleSuccessMessageAlert('Your password is successfully changed')
  } catch (err) {
    let errorMessage = ''
    if (Array.isArray(err.response.data.errors)) {
      errorMessage = err.response.data.errors[0]
    } else if (err.response.data.errorMessage) {
      errorMessage = err.response.data.errorMessage
    }
    dispatch(actions.changePasswordFail(errorMessage))
  }
}

export const restPassword = (email: string): ThunkAction => {
  return async dispatch => {
    dispatch(actions.restPasswordRequest())

    try {
      const resp = await axios.post('public/password/reset', email, {
        headers: { 'Content-Type': 'text/plain' }
      })
      dispatch(actions.restPasswordSuccess(resp.data))
      // history.push(routePath.CHECK_EMAIL)
    } catch (err) {
      // handleErrorMessageAlert(err.response.data.errorMessage)
      const {
        response: {
          data: { errorMessage }
        }
      } = err
      dispatch(actions.restPasswordFail(errorMessage))
    }
  }
}

export const changePasswordByEmail = (
  code: string,
  password: string
): ThunkAction => {
  return async dispatch => {
    dispatch(actions.changePasswordByEmailRequest())

    try {
      const resp = await axios.post('public/password/change', {
        // @ts-ignore
        // maxNumbersOfEntries: 10,
        password,
        resetCode: code
      })
      // console.log(resp)
      dispatch(actions.changePasswordByEmailSuccess(resp.data))
      history.push(routePath.AUTH)
    } catch (err) {
      // handleErrorMessageAlert(err.response.data.errorMessage)
      dispatch(
        actions.changePasswordByEmailFail(err.response.data.errorMessage)
      )
    }
  }
}
